// Form configuration data for different clients
export const formConfigurations = {
  // Default configuration
  default: {
    formId: 'default',
    formName: '기본 폼',
    triggerType: 'button', // 'auto' | 'button'
    triggerButtonText: '고객 센터 문의',
    submitClipboardTextTemplate: '이름: {{name}} \n이메일: {{email}} \n전화번호: {{phone}} \n\n상품 목록: \n{{productsList}}',
    fields: [
      {
        id: 'email',
        type: 'email',
        label: '이메일을 입력해 주세요.',
        placeholder: 'example@example.com',
        required: true,
        validation: {
          type: 'email',
          pattern: /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)?@[^\s@]+\.[^\s@]+$/,
          errorMessage: '올바른 형식의 이메일 주소를 입력해 주세요'
        }
      },
      {
        id: 'name',
        type: 'text',
        label: '이름/회사명을 입력해 주세요.',
        placeholder: '이름/회사명을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '이름을 입력해 주세요'
        }
      },
      {
        id: 'phone',
        type: 'tel',
        label: '본인 확인을 위해 전화번호를 입력해 주세요. (-제외)',
        placeholder: '01012341234',
        required: true,
        validation: {
          type: 'phone',
          pattern: /^010\d{8}$/,
          maxLength: 11,
          errorMessage: '010으로 시작하는 9자리 이상 숫자를 입력해주세요'
        }
      }
    ],
    checkboxGroup: {
      enabled: false,
    },
    submitButton: {
      text: '최저가 견적 안내 받기',
      disabledText: '모든 필드를 입력해 주세요'
    }
  },

  // FastFive prod specific configuration
  '67615284c5ff44110dbc6613': {
    formId: 'fastfive',
    formName: 'FastFive 폼',
    triggerType: 'auto',
    triggerButtonText: 'FastFive 견적 받기',
    submitClipboardTextTemplate: '이름: {{name}} \n이메일: {{email}} \n전화번호: {{phone}} \n\n상품 목록: \n{{productsList}}',
    fields: [
      {
        id: 'email',
        type: 'email',
        label: '견적을 받으실 이메일을 입력해 주세요.',
        placeholder: 'example@example.com',
        required: true,
        validation: {
          type: 'email',
          pattern: /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)?@[^\s@]+\.[^\s@]+$/,
          errorMessage: '올바른 형식의 이메일 주소를 입력해 주세요'
        }
      },
      {
        id: 'name',
        type: 'text',
        label: '이름/회사명을 입력해 주세요.',
        placeholder: '이름/회사명을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '이름을 입력해 주세요'
        }
      },
      {
        id: 'phone',
        type: 'tel',
        label: '본인 확인을 위해 전화번호를 입력해 주세요. (-제외)',
        placeholder: '01012341234',
        required: true,
        validation: {
          type: 'phone',
          pattern: /^010\d{8}$/,
          maxLength: 11,
          errorMessage: '010으로 시작하는 9자리 이상 숫자를 입력해주세요'
        }
      }
    ],
    checkboxGroup: {
      enabled: true,
      title: '약관에 모두 동의합니다.',
      checkboxes: [
        {
          id: 'checkPrivacyPolicy',
          label: '상담을 위한 개인정보 수집과 이용 동의 (필수)',
          required: true,
          link: {
            text: '개인정보 수집과 이용',
            url: 'https://waddlelab.notion.site/1741f2d71bda80b49b97c0f082874a0d?pvs=4'
          }
        },
        {
          id: 'checkMarketing',
          label: '혜택 안내를 위한 마케팅 활용 동의 (선택)',
          required: false,
          link: {
            text: '마케팅 활용',
            url: 'https://waddlelab.notion.site/1741f2d71bda805183a3e7066b2f2268?pvs=4'
          }
        }
      ]
    },
    submitButton: {
      text: '최저가 견적 안내 받기',
      disabledText: '모든 필드를 입력해 주세요'
    }
  },

  // fastfive dev specific configuration
  '67516ecf103e7e29c75a621e': {
    formId: 'fastfiveDev',
    formName: 'FastFive Dev 폼',
    triggerType: 'auto',
    triggerButtonText: 'FastFive Dev 견적 받기',
    submitClipboardTextTemplate: '이름: {{name}} \n이메일: {{email}} \n전화번호: {{phone}} \n\n상품 목록: \n{{productsList}}',
    fields: [
      {
        id: 'email',
        type: 'email',
        label: '견적을 받으실 이메일을 입력해 주세요.',
        placeholder: 'example@example.com',
        required: true,
        validation: {
          type: 'email',
          pattern: /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)?@[^\s@]+\.[^\s@]+$/,
          errorMessage: '올바른 형식의 이메일 주소를 입력해 주세요'
        }
      },
      {
        id: 'name',
        type: 'text',
        label: '이름/회사명을 입력해 주세요.',
        placeholder: '이름/회사명을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '이름을 입력해 주세요'
        }
      },
      {
        id: 'phone',
        type: 'tel',
        label: '본인 확인을 위해 전화번호를 입력해 주세요. (-제외)',
        placeholder: '01012341234',
        required: true,
        validation: {
          type: 'phone',
          pattern: /^010\d{8}$/,
          maxLength: 11,
          errorMessage: '010으로 시작하는 9자리 이상 숫자를 입력해주세요'
        }
      }
    ],
    checkboxGroup: {
      enabled: true,
      title: '약관에 모두 동의합니다.',
      checkboxes: [
        {
          id: 'checkPrivacyPolicy',
          label: '상담을 위한 개인정보 수집과 이용 동의 (필수)',
          required: true,
          link: {
            text: '개인정보 수집과 이용',
            url: 'https://waddlelab.notion.site/1741f2d71bda80b49b97c0f082874a0d?pvs=4'
          }
        },
        {
          id: 'checkMarketing',
          label: '혜택 안내를 위한 마케팅 활용 동의 (선택)',
          required: false,
          link: {
            text: '마케팅 활용',
            url: 'https://waddlelab.notion.site/1741f2d71bda805183a3e7066b2f2268?pvs=4'
          }
        }
      ]
    },
    submitButton: {
      text: '최저가 견적 안내 받기',
      disabledText: '모든 필드를 입력해 주세요'
    }
  },

  // Simple form without checkboxes
  csInquiry: {
    formId: 'csInquiry',
    formName: 'CS 문의 폼',
    triggerType: 'button',
    triggerButtonText: '고객 센터 문의',
    supportiveType: {
      tel: false,
      kakao: false,
    },
    supportiveUrl: {
      tel: '',
      kakao: '',
    },
    submitClipboardTextTemplate: '이름: {{name}} \n전화번호: {{phone}} \n문의 내용: {{inquiry}} \n\n상품 목록: \n{{productsList}}',
    fields: [
      {
        id: 'name',
        type: 'text',
        label: '이름을 입력해 주세요.',
        placeholder: '이름을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '이름을 입력해 주세요'
        }
      },
      {
        id: 'phone',
        type: 'tel',
        label: '전화번호를 입력해 주세요. (-제외)',
        placeholder: '01012341234',
        required: true,
        validation: {
          type: 'phone',
          pattern: /^010\d{8}$/,
          maxLength: 11,
          errorMessage: '010으로 시작하는 9자리 이상 숫자를 입력해주세요'
        }
      },
      {
        id: 'inquiry',
        type: 'textarea',
        label: '문의 내용을 입력해 주세요.',
        placeholder: '문의 내용을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '문의 내용을 입력해 주세요'
        }
      }
    ],
    checkboxGroup: {
      enabled: false
    },
    submitButton: {
      text: '제출하기',
      disabledText: '모든 필드를 입력해 주세요',
    }
  },

  // Arfu dev specific configuration
  '6889e08a9c3c5a7847792be6': {
    formId: 'csInquiry',
    formName: 'CS 문의 폼',
    triggerType: 'button',
    triggerButtonText: '가구견적문의 바로가기',
    supportiveType: {
      tel: false,
      kakao: false,
    },
    supportiveUrl: {
      tel: '1577-6190',
      kakao: 'http://pf.kakao.com/_xoCwxixl/chat',
    },
    submitClipboardTextTemplate: '이름: {{name}} \n전화번호: {{phone}} \n문의 내용: {{inquiry}} \n\n상품 목록: \n{{productsList}}',
    fields: [
      {
        id: 'name',
        type: 'text',
        label: '이름을 입력해 주세요.',
        placeholder: '이름을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '이름을 입력해 주세요'
        }
      },
      {
        id: 'phone',
        type: 'tel',
        label: '전화번호를 입력해 주세요. (-제외)',
        placeholder: '01012341234',
        required: true,
        validation: {
          type: 'phone',
          pattern: /^010\d{8}$/,
          maxLength: 11,
          errorMessage: '010으로 시작하는 9자리 이상 숫자를 입력해주세요'
        }
      },
      {
        id: 'inquiry',
        type: 'textarea',
        label: '문의 내용을 입력해 주세요.',
        placeholder: '문의 내용을 입력해 주세요',
        required: true,
        validation: {
          type: 'text',
          minLength: 1,
          errorMessage: '문의 내용을 입력해 주세요'
        }
      }
    ],
    checkboxGroup: {
      enabled: false
    },
    submitButton: {
      text: '제출하기',
      disabledText: '모든 필드를 입력해 주세요',
      externalLink: 'http://pf.kakao.com/_xoCwxixl/chat',
    }
  },
};

// Validation functions
export const validationFunctions = {
  email: (value, config) => {
    if (!config.pattern) return true;
    return config.pattern.test(value);
  },
  
  text: (value, config) => {
    if (config.minLength && value.length < config.minLength) return false;
    if (config.maxLength && value.length > config.maxLength) return false;
    return true;
  },
  
  phone: (value, config) => {
    if (config.maxLength && value.length > config.maxLength) return false;
    if (config.pattern) {
      return config.pattern.test(value);
    }
    return true;
  },
  
  tel: (value, config) => {
    return validationFunctions.phone(value, config);
  }
};

// Helper function to get form configuration
export const getFormConfig = (clientId = 'default') => {
  return formConfigurations[clientId] || formConfigurations.csInquiry;
};
